var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVisible,
          expression: "isVisible",
        },
      ],
      class: [
        "qr-code-widget",
        "d-none",
        "d-lg-block",
        _vm.isExpanded ? "expanded" : "collapsed",
      ],
    },
    [
      _c(
        "div",
        {
          staticClass: "qr-main-content",
          on: { click: _vm.handleMainContentClick },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "qr-control-btn",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.hideQrCode.apply(null, arguments)
                },
              },
            },
            [
              _c("img", {
                staticStyle: { height: "14px" },
                attrs: {
                  src: require("@/assets/images/arrow_left.png"),
                  alt: "",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "qr-collapsed-btn", on: { click: _vm.showQrCode } },
        [
          _c("img", {
            staticStyle: { height: "14px", transform: "rotate(180deg)" },
            attrs: { src: require("@/assets/images/arrow_left.png"), alt: "" },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "qr-body" }, [
      _c("img", {
        staticClass: "qr-image",
        attrs: {
          src: require("@/assets/images/39down.png"),
          alt: "下载二维码",
        },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "qr-description" }, [
        _vm._v("扫描下载39游戏盒子有惊喜"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }